export default __webpack_public_path__ + "static/media/mappp.7d98ba39.png";